import { useState } from 'react';

export function AmenitiesFilter({ amenities, onChange }) {
    const [checkedAmenities, setCheckedAmenities] = useState([]);
    const [open, setOpen] = useState(false);

    const importantAmenities = ['Pet Friendly', 'Accessibility'];

    // divide group into important and drawer amenities
    const highlightAmenities = amenities.filter((item) => importantAmenities.includes(item));
    const drawerAmenities    = amenities.filter((item) => !importantAmenities.includes(item));

    const handleChange = (e) => {
        let newCheckedAmenities = [...checkedAmenities];
        if(e.target.checked) {
            newCheckedAmenities.push(e.target.value);
        } else {
            newCheckedAmenities = checkedAmenities.filter((item) => e.target.name !== item);
        }
        setCheckedAmenities(newCheckedAmenities);
        onChange(newCheckedAmenities);
    };

    return(
        <div className="amenities-filter">
            {highlightAmenities.map((amenity, index) => (
                <div key={index} className="amenities-filter__button">
                    <input type="checkbox" name={ amenity } value={ amenity } onChange={handleChange} id={ amenity } />
                    <label htmlFor={ amenity }>{ amenity }</label>
                </div>
            ))}
            <div className={ open ? ' amenities-filter--opened' : 'amenities-filter--closed'}>
                <a className="amenities-filter__more" onClick={ () => { setOpen(!open) } }>Show More Features</a>
                <div className="amenities-filter__drawer">
                    {drawerAmenities.map((amenity, index) => (
                        <div key={index} className="amenities-filter__button">
                            <input type="checkbox" name={ amenity } value={ amenity } onChange={handleChange} id={ amenity } />
                            <label htmlFor={ amenity }>{ amenity }</label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}